import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { SuggestRequestModel } from '../../models/suggest-request-model';
import { ConstantsService } from '../../services/constants.service';
import { PubSearchService } from '../../services/pub-search.service';
import { QueryStateService } from '../../services/query-state.service';
import { FoldersService } from '../../services/folders.service';
import { ResultSelectionService } from '../../services/result-selection.service';

@Component({
  selector: 'app-search-simple-form',
  templateUrl: './search-simple-form.component.html',
  styleUrls: ['./search-simple-form.component.css']
})
export class SearchSimpleFormComponent implements OnInit {
  get isKeywordValid(): boolean {
    const kw = this.searchForm?.controls["keywords"]?.value || '';
    return typeof kw === 'string' && kw.trim().length >= 3;
  }

  @Input() searchForm: FormGroup = new FormGroup({});

  spaceOperator: string = ' ';
  notOperator: string = '-';
  showCombined = false;
  aSugs: string[] = [];
  loadSearchVisible: boolean = false;
  selectedLib: string

  constructor(private fb: FormBuilder,
    private constants: ConstantsService,
    private router: Router,
    private queryStateSvc: QueryStateService,
    private searchSvc: PubSearchService,
    private folderSvc: FoldersService,
    public selectionSvc: ResultSelectionService) {
    this.selectedLib = this.constants.indexEHD;
  }

  ngOnInit(): void {
    this.folderSvc.selectedLibrary$.subscribe(l => {
      this.selectedLib = l;
      // console.log('Simple Search selected lib changed: ' + this.selectedLib);
    });

    this.initForm();
  }

  initForm() {
    this.searchForm.controls["indexId"].setValue(this.selectedLib);
  }

  getSuggestions(event: any) {
    // don't call if the length is greater than 100
    if (event.query.length > 2 && event.query.length < 300) {
      let suggestQuery: SuggestRequestModel = { q: event.query, top: 25, suggester: this.constants.azSuggester, indexId: this.selectedLib };
      this.searchSvc.getSuggestions(suggestQuery).subscribe((data: string[]) => {
        // console.log("suggestions: " + JSON.stringify(data));
        this.aSugs = data;
      });
    }
  }

  kwSuggestionSelected(value: any) {
    // add quotes to selected items for auto-complete.
    this.searchForm.controls["keywords"].setValue(this.makeQuoted(value.value));
  }

  clearKeyword() {
    this.searchForm.controls["keywords"].setValue('');
  }

  makeQuoted(value: string): string {
    return "\"" + value + "\"";
  }

  clearSearch() {
    this.searchForm.controls["keywords"].setValue('');
  }

  advSearch() {
    this.router.navigate(['/adv-search']);
  }

  loadSearch() {
    this.loadSearchVisible = true;
  }

  executeLoadSearch(query: any) {
    this.loadSearchVisible = false;
    this.queryStateSvc.updateFormData(query);
    this.selectionSvc.clearAll();

    this.router.navigate([
      '/results/' + encodeURIComponent(JSON.stringify(this.queryStateSvc.getFormData())),
    ]);
  }

  closeLoadSearch() {
    this.loadSearchVisible = false;
  }

  submitForm() {
    // console.log('Submit Simple Search for lib: ' + this.selectedLib);
    this.searchForm.controls["indexId"].setValue(this.selectedLib);

    // Update the form values in the query state service which drives functions
    this.queryStateSvc.updateFormData(this.searchForm.value); // Will update/create the Search request in the Query Service.

    this.selectionSvc.clearAll();
    this.router.navigate([
      '/results/' + encodeURIComponent(JSON.stringify(this.queryStateSvc.getFormData())),
    ]);
  }
}
